export enum EntidadTicketEnum {
  Operacion = 'operacion',
  Borrador = 'borrador',
  Factura = 'factura'
}